<div *ngIf="!getSessionExpired" class="col-12">
    <div class="card-body" *ngIf="analytics.TransactionCount > 0; else noTransactions">
        <h2 class="card-title" style="text-align: center;">Изберете вашата цел за текущият месец</h2>
        <div class="col-lg-4 col-lg-offset-6 col-centered pt-3 mb-5">
            <form [formGroup]="form">
                <div class="input-group mb-3">
                    <div class="input-group mb-3">
                        <select formControlName="selection" class="form-control"
                            (change)="onSelectionChange($event.target.value)">
                            <option value="" [selected]="!selectedOption" disabled>В момента няма зададена цел</option>
                            <option value="moreRevenue" [selected]="selectedOption === 'moreRevenue'">Повече приходи,
                                по-малко разходи</option>
                            <option value="costMatching" [selected]="selectedOption === 'costMatching'">Приравняване на
                                разходите и приходите</option>
                            <option value="savingAmount" [selected]="selectedOption === 'savingAmount'">Спестяване на
                                определена сума</option>
                        </select>
                    </div>

                    <div class="input-group mb-3" *ngIf="selectedOption === 'savingAmount'">
                        <input type="number" name="savingAmountInput" formControlName="savingAmountInput"
                            placeholder="Въвеждането на желаната от вас сума е задължително" class="form-control">
                    </div>
                </div>
                <div class="input-group-btn d-flex justify-content-center">
                    <button type="submit" class="btn btn-primary" (click)="changeSelection()">Задаване на цел</button>
                </div>
            </form>
        </div>
        <div class="statistics col-12">
            <div class="col-12 p-5">
                <canvas mdbChart id="pieChart" *ngIf="chartData.length != 0" [chartType]="chartType" [data]="chartData"
                    [labels]="chartLabels" [colors]="chartColors" [options]="chartOptions" [legend]="true">
                </canvas>
            </div>
            <div style="text-align: center;" class="col-lg-6 col-lg-offset-6 col-centered pt-3">

                <!-- Повече приходи, по-малко разходи -->
                <h5
                    *ngIf="chartSelection =='moreRevenue' && (analytics.amountOfMostCommonTransactionType == 'Разход' || analytics.amountOfMostCommonTransactionType == 'Разходи')">
                    За съжаление сте далеч от целта си, защото в момента имате повече трансакции от тип
                    <b>"{{analytics.amountOfMostCommonTransactionType}}"</b>. Помислете как да се доближите до целта си
                    или можете да се консултирате с нашия <a [routerLink]="['/openai']">"Помощник"</a>.!
                </h5>

                <h5
                    *ngIf="chartSelection =='moreRevenue' && (analytics.amountOfMostCommonTransactionType == 'Приход' || analytics.amountOfMostCommonTransactionType == 'Приходи')">
                    Поздравления! Вашата цел е успешна към този момент. Продължавайте в същият дух и задръжте
                    резултатите
                    си за
                    по-дълго, за успешна цел. В момента имате повече трансакции от тип
                    <b>"{{analytics.amountOfMostCommonTransactionType}}"</b>.
                </h5>

                <!-- Приравняване на разходите и приходите -->
                <h5 *ngIf="chartSelection == 'costMatching' && incomeTotal == expenseTotal">
                    Поздравления! Вашата цел е успешна към този момент. Вие имате приходи на стойност {{incomeTotal}} и
                    разходи на стойност {{expenseTotal}}.
                </h5>

                <h5 *ngIf="chartSelection == 'costMatching' && incomeTotal > expenseTotal">
                    За съжаление целта Ви е неуспешна към този момент. В момента имате повече приходи от колкото
                    разходи, което не изпълнява условията на вашата цел.
                    Задайте вашите финансови въпроси към нашия <a [routerLink]="['/openai']">"Помощник"</a>.
                </h5>

                <h5 *ngIf="chartSelection == 'costMatching' && incomeTotal < expenseTotal">
                    За съжаление целта Ви е неуспешна към този момент. В момента имате повече разходи от колкото
                    приходи, което не изпълнява условията на вашата цел.
                    Задайте вашите финансови въпроси към нашия <a style="color:aqua !important"
                        [routerLink]="['/openai']">"Помощник"</a>.
                </h5>

                <!-- Спестяване на определена сума -->
                <h5 *ngIf="chartSelection == 'savingAmount' && this.analytics.savedAmount > savingAmount">
                    Поздравления! Вашата цел е успешна към този момент. В момента имате спестени
                    {{analytics.savedAmount}} лв. Продължавайте в същия дух, за да задържите резултатите си и да имате
                    успешна цел.
                </h5>

                <h5 *ngIf="chartSelection == 'savingAmount' && this.analytics.savedAmount < savingAmount">
                    За съжаление вашата цел е неусшена към този момент! В момента нямате толкова спестени пари. Опитайте
                    се да изкарате повече пари и да намалите вашите разходи, за да достигнете целта си.
                </h5>
            </div>
        </div>
    </div>

    <ng-template #noTransactions>
        <app-no-data class="center"></app-no-data>
    </ng-template>

</div>

<app-calculator></app-calculator>

<footer>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h3>За нас</h3>
                <p>Ние от MYLEV сме екип от професионалисти в областта на финансите, които вярват, че всеки заслужава
                    да
                    има
                    контрол върху своите финанси. С нашата приложна програма може да проследите разходите си, да
                    получите подробна
                    информация за финансовото си състояние и да управлявате сметките си докато сте в движение.</p>
            </div>
            <div class="col-md-3">
                <h3>За връзка</h3>
                <ul>
                    <li>Димитър Найденов 100</li>
                    <li>Велико Търново, България</li>
                    <li>Email: info@mylev.com</li>
                </ul>
            </div>
            <div class="col-md-3">
                <h3>Последвайте ни в</h3>
                <ul>
                    <li><a href="#">Facebook</a></li>
                    <li><a href="#">Twitter</a></li>
                    <li><a href="#">Instagram</a></li>
                    <li><a href="#">LinkedIn</a></li>
                </ul>
            </div>
        </div>
        <hr>
        <p>Изработено от <a href="http://temelkov.tk" target="_blank">Станислав Tемелков</a> &copy; MYLEV 2023</p>
    </div>
</footer>